import React from "react";
import Styles from "./style.module.scss";
import Images from "@Theme/Images";
import Button from "@Atom/Button";
import Icon from "@Atom/Icon";
import { fileBaseUrl } from "@Config/index";
import { useNavigate } from "react-router-dom";

export default function ClassesCard({
  title,
  image,
  isPrakerja,
  type,
  level,
  totalStudent = 1200,
  rating = "4.5",
  id,
  buttonText = "Detail Kelas",
  navigateTo = "",
}) {
  const navigate = useNavigate();
  return (
    <div className={Styles.container}>
      <div className={Styles.imageWrapper}>
        <img
          src={image.includes("https") ? image : fileBaseUrl + image}
          alt="banner"
        />
      </div>
      <div className={Styles.bodyWrapper}>
        <div className={Styles.cardBody}>
          <div className={Styles.cardTag}>
            <div className={Styles.tag} type="level">
              <p>{level}</p>
            </div>
            <div className={Styles.tag} type="type">
              <p>{type}</p>
            </div>
            {isPrakerja && (
              <img
                src={Images.LOGO_PRAKERJA}
                alt="prakerja"
                className={Styles.prakerjaLogo}
              />
            )}
          </div>
          <div className={Styles.cardTitle}>
            <p>{title}</p>
          </div>
          <div className={Styles.cardFooter}>
            <div className={Styles.cardDesc}>
              <Icon icon={"user-group"} size={16} color={"#9E9E9E"} />
              <p>{totalStudent}</p>
            </div>
            <div className={Styles.cardDesc}>
              <Icon icon={"star"} size={16} color={"#ECBE6C"} />
              <p>{rating}</p>
            </div>
          </div>
        </div>
        <div className={Styles.cardAction}>
          <Button
            text={buttonText}
            variant="outlined"
            className={Styles.cardButton}
            onClick={() =>
              navigateTo ? navigate(`${navigateTo}`) : navigate(`${id}`)
            }
          />
        </div>
      </div>
    </div>
  );
}
